import type { NavigateFunction } from 'react-router-dom'

/**
 * Navigate to the terminal and auto-run a command on arrival.
 * Terminal.tsx picks up the stored command on mount.
 */
export function navigateToTerminalCommand(navigate: NavigateFunction, command: string) {
  sessionStorage.setItem('terminal-autorun', command)
  navigate('/app/terminal')
}
